window.addEventListener('load', function() {
	if (window.outerWidth > 1024) {
		const blogSlider = new Swiper('.blog-list-content__gallery', {
			wrapperClass: 'blog-list-content__gallery-track',
			slideClass: 'blog-list-content__gallery-item',
			speed: 500,
			slidesPerView: 1
		});

		document.querySelectorAll('section.blog-list .blog-list__gallery-item').forEach(item => {
			item.addEventListener('mouseenter', function(){
				document.querySelector('section.blog-list .blog-list__gallery-item--active').classList.remove('blog-list__gallery-item--active');
				this.classList.add('blog-list__gallery-item--active');

				let index = this.dataset.index - 1;
				blogSlider.slideTo(index);
			})
		})
	} else {
		const blogSlider = new Swiper('.blog-list-content__gallery', {
			wrapperClass: 'blog-list-content__gallery-track',
			slideClass: 'blog-list-content__gallery-item',
			speed: 500,
			slidesPerView: 'auto',
			autoHeight: true
		});

		const gallerySlider = new Swiper('.blog-list__gallery', {
			wrapperClass: 'blog-list__gallery-track',
			slideClass: 'blog-list__gallery-item',
			speed: 500,
			slidesPerView: 'auto'
		});

		blogSlider.controller.control = gallerySlider;
		gallerySlider.controller.control = blogSlider;
	}
}, false);